import { z } from 'zod';

const templateButtonSchema = z.object({
  type: z.enum(['URL', 'QUICK_REPLY', 'PHONE_NUMBER']),
  text: z.string(),
  url: z.string().optional(),
  phone_number: z.string().optional(),
  example: z.array(z.string()).optional(),
});

export const whatsappTemplateComponentSchema = z.object({
  type: z.enum(['HEADER', 'BODY', 'FOOTER', 'BUTTONS']),
  format: z.enum(['TEXT', 'IMAGE', 'VIDEO', 'DOCUMENT']).optional(),
  text: z.string().optional(),
  buttons: z.array(templateButtonSchema).optional(),
  example: z
    .object({
      body_text: z.array(z.array(z.string())).optional(),
      header_text: z.array(z.string()).optional(),
      header_url: z.array(z.string()).optional(),
    })
    .optional(),
});

export type WhatsAppTemplateComponent = z.infer<typeof whatsappTemplateComponentSchema>;

const carouselCardSchema = z.object({
  components: z.array(whatsappTemplateComponentSchema),
});

const carouselComponentSchema = z.object({
  type: z.literal('CAROUSEL'),
  cards: z.array(carouselCardSchema).min(2).max(10),
});

export const createWhatsappTemplateSchema = z.object({
  name: z.string().min(1).max(512),
  language: z.string().default('en_US'),
  category: z.enum(['MARKETING', 'UTILITY', 'AUTHENTICATION']),
  components: z.array(z.union([whatsappTemplateComponentSchema, carouselComponentSchema])).min(1),
  /** Business accounts to create on; omitted = every account of the platform. */
  waba_ids: z.array(z.string().min(1)).optional(),
});

export type CreateWhatsAppTemplateDto = z.infer<typeof createWhatsappTemplateSchema>;

export const whatsappTemplateSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  language: z.string(),
  category: z.string(),
  components: z.unknown(),
  status: z.string(),
  meta_template_id: z.string().nullable().optional(),
  rejected_reason: z.string().nullable().optional(),
  whatsapp_business_account_id: z.string(),
  created_at: z.date().or(z.string().datetime()),
  updated_at: z.date().or(z.string().datetime()),
});

export type WhatsAppTemplate = z.infer<typeof whatsappTemplateSchema>;
